import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../../../components/form/form-field';
import SaveButton from '../../../../../components/form/save-button';
import { useNodeContext } from '../../../../../context/node-context';

const CopyFileTaskForm = ({
  form,
  onSubmit,
  onChange,
}: {
  form: any;
  onSubmit: any;
  onChange: any;
}) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext() as { node: any };
  const { id: _id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="copyFileTaskFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />
      <FormField
        controlId="copyFileTaskFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />
      <FormField
        controlId="copyFileTaskFormFunction"
        label="function"
        name="function"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.function?.message}
        defaultValue="copyFile"
      />
      <FormField
        controlId="copyFileTaskFormCredentials"
        label="credentials"
        name="parameters.credentials"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter credentials"
        error={errors.parameters?.credentials?.message}
      />
      <FormField
        controlId="copyFileTaskFormPort"
        label="port"
        name="parameters.port"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter port"
        error={errors.parameters?.port?.message}
      />
      <FormField
        controlId="copyFileTaskFormSource"
        label="source"
        name="parameters.source"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter source"
        required
        error={errors.parameters?.source?.message}
      />
      <FormField
        controlId="copyFileTaskFormTarget"
        label="target"
        name="parameters.target"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter target"
        required
        error={errors.parameters?.target?.message}
      />
      <FormField
        controlId="copyFileTaskFormResult"
        label="result"
        name="parameters.result"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter result"
        required
        error={errors.parameters?.result?.message}
      />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default CopyFileTaskForm;
